import React from 'react'
import { List } from 'immutable'
import { Switch, Route } from 'react-router'

import * as pages from '../pages'

const routesMap = {
  signin: {
    pattern: '/sign-in',
    component: pages.SignIn,
    exactly: true,
  },
  privateArea: {
    pattern: '/',
    component: pages.Authorized,
    routes: {
      results: {
        pattern: '/results',
        component: pages.Results,
        exactly: true,
      },
      result: {
        pattern: '/results/:result',
        component: pages.Result,
        exactly: true,
      },
      newResult: {
        pattern: '/newresult/:driver',
        component: pages.NewResult,
        exactly: true,
      },
      drivers: {
        pattern: '/drivers',
        component: pages.Drivers,
        exactly: true,
      },
      newDriver: {
        pattern: '/drivers/new',
        component: pages.Driver,
        exactly: true,
      },
      importDrivers: {
        pattern: '/drivers/import',
        component: pages.DriversImport,
        exactly: true,
      },
      driver: {
        pattern: '/drivers/:driver',
        component: pages.Driver,
        exactly: true,
      },
      driverFrom: {
        pattern: '/drivers/:driver/:attendSource',
        component: pages.Driver,
        exactly: true,
      },
      attendpdf: {
        pattern: '/attendpdf/:attendance',
        component: pages.AttendanceOwnPdf,
        exactly: true,
      },
      attendpdffeedbacks: {
        pattern: '/attendpdffeedbacks/:attendance',
        component: pages.AttendanceFeedbacksPdf,
        exactly: true,
      },
      newAttendance: {
        pattern: '/attendheader/new',
        component: pages.AttendanceHeader,
        exactly: true,
      },
      attendanceHeader: {
        pattern: '/attendheader/:attendance',
        component: pages.AttendanceHeader,
        exactly: true,
      },
      attendances: {
        pattern: '/attendances',
        component: pages.Attendances,
        exactly: true,
      },
      attendance: {
        pattern: '/attendances/:attendance',
        component: pages.Attendance,
        exactly: true,
      },
      companies: {
        pattern: '/companies',
        component: pages.Companies,
        exactly: true,
      },
      newCompany: {
        pattern: '/companies/new',
        component: pages.Company,
        exactly: true,
      },
      company: {
        pattern: '/companies/:company',
        component: pages.Company,
        exactly: true,
      },
      locations: {
        pattern: '/locations',
        component: pages.Locations,
        exactly: true,
      },
      newLocation: {
        pattern: '/locations/new',
        component: pages.Location,
        exactly: true,
      },
      location: {
        pattern: '/locations/:location',
        component: pages.Location,
        exactly: true,
      },
      users: {
        pattern: '/users',
        component: pages.Users,
        exactly: true,
      },
      newUser: {
        pattern: '/users/new',
        component: pages.User,
        exactly: true,
      },
      user: {
        pattern: '/users/:user',
        component: pages.User,
        exactly: true,
      },
      settings: {
        pattern: '/settings',
        component: pages.Settings,
        exactly: true,
      },
      redirect: {
        pattern: '/',
        component: pages.Redirect,
        exactly: true,
      },
    },
  },
}

const routes = Object.keys(routesMap).map(key => routesMap[key])
export const links = routesMap

const _switchWithRoutes = (props) => {
  const { routes, resourceNotFound } = props
  return (
    <Switch>
      {resourceNotFound
        ? <Route component={pages.NotFound} />
        : routes.map((route, i) => (
          <Route
            key={i}
            path={route.pattern}
            exact={route.exactly}
            strict={route.strict}
            render={props => (
              <route.component {...props} routes={route.routes} />
            )}
          />
        ))
      }
      {!resourceNotFound && <Route component={pages.NotFound} />}
    </Switch>
  )
}
_switchWithRoutes.defaultProps = {
  resourceNotFound: false,
}
_switchWithRoutes.contextTypes = {
  router: React.PropTypes.object.isRequired,
}
_switchWithRoutes.propTypes = {
  routes: React.PropTypes.any.isRequired,
  resourceNotFound: React.PropTypes.bool,
}
export const SwitchWithRoutes = _switchWithRoutes

export const flattenRoutes = (routes, components = new List()) => {
  const flattened = Object.keys(routes).reduce((flatRoutes, key) => {
    const route = routes[key]
    const routeComponents = components.push(route.component)
    flatRoutes = flatRoutes.concat([{
      pattern: route.pattern,
      components: routeComponents.toJS(),
      exact: route.exactly || false,
      strict: route.strict || false,
    }])
    if (route.routes) flatRoutes = flatRoutes.concat(flattenRoutes(route.routes, routeComponents))
    return flatRoutes
  }, [])
  return flattened
}

export default routes



// WEBPACK FOOTER //
// ./src/browser/app/routes.js